import { render, staticRenderFns } from "./AuthorizationCodeStatistics.vue?vue&type=template&id=044c8b84&scoped=true&"
import script from "./AuthorizationCodeStatistics.vue?vue&type=script&lang=js&"
export * from "./AuthorizationCodeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationCodeStatistics.vue?vue&type=style&index=0&id=044c8b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c8b84",
  null
  
)

export default component.exports